import React from "react"
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';
import CheckIcon from '@mui/icons-material/Check';
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

function MinimizeButton(props) {
  if (props.renderAsMenuItem) {
    return (
      <MenuItem
        onClick={() => {
          props.toggleMinimizeMode();
          props.onMenuItemClick?.();
        }}
        sx={{ py: 1.25 }}
      >
        <ListItemIcon sx={{ color: props.minimizeMode ? "#6d28d9" : undefined }}>
          <UnfoldLessIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText
          primaryTypographyProps={{
            fontSize: 14,
            color: props.minimizeMode ? "#6d28d9" : undefined,
            fontWeight: props.minimizeMode ? 600 : 400,
          }}
        >
          Compact rows
        </ListItemText>
        {props.minimizeMode && (
          <CheckIcon sx={{ color: "#6d28d9", fontSize: 18 }} />
        )}
      </MenuItem>
    );
  }

  return(
    <Tooltip title="Minimize Schedule">
      <IconButton
        style={{ color: props.minimizeMode ? "#6d28d9" : undefined }}
        className="group-hover:bg-gray-200 transition"
        onClick={props.toggleMinimizeMode}
      >
        <UnfoldLessIcon />
      </IconButton>
    </Tooltip>
  )
}

export default MinimizeButton
